import { configTracking } from './config/configTracking';
import ninjaConfig from './config/ninja';
import regionConfig from './config/region';
import { checkParam, currentSession, currentTracker, getPluginList, trackError } from './core';
import { flushDelayed, trackEventDelayed, trackPageDelayed } from './core/delayedTracking';
import { init as initLaquesis } from './trackers/laquesis';
import { eucex, extend, getCurrentPath, inArray, isArray } from './utils';

try {
  var currentPush;
  var foundTrackPage;
  var tmp;

  if (regionConfig.custom[ninjaConfig.siteUrl]) {
    // Setup dataLayer
    ninjaConfig.dataLayer = ninjaConfig.dataLayer || [];
    ninjaConfig.dataLayerDelayed = ninjaConfig.dataLayerDelayed || [];

    // Overwrite function push
    currentPush = ninjaConfig.dataLayer.push;
    ninjaConfig.dataLayer.push = function (params) {
      var result = currentPush.apply(ninjaConfig.dataLayer, [params]);

      checkParam();

      return result;
    };

    // Set internal queue
    if (!window.trackingQueue) {
      window.trackingQueue = [];
    }
    window.trackingQueue.push = function (func) {
      if (typeof func === 'function') {
        func();
        return 0;
      }
      return -1;
    };

    // delayed queue
    // if (!window.trackingQueueDelayed) {
    //   window.trackingQueueDelayed = [];
    // }
    // window.trackingQueueDelayed.push = function (func) {
    //   if (typeof func === 'function') {
    //     func();
    //     return 0;
    //   }
    //   return -1;
    // };

    while (window.trackingQueue.length > 0) {
      window.trackingQueue.push(window.trackingQueue.shift());
    }

    // Call async check
    for (var j in ninjaConfig.dataLayer) {
      if (Object.prototype.hasOwnProperty.call(ninjaConfig.dataLayer, j)) {
        tmp = ninjaConfig.dataLayer[j];
        if (tmp.trackPage) {
          foundTrackPage = true;
        }
      }
    }
    if (!foundTrackPage && !ninjaConfig.disableDefaultTrackPage) {
      if (!configTracking.unitTest) {
        if (window.location.pathname) {
          // Track the current path name if there is no trackPage when the library is called
          ninjaConfig.dataLayer.push({ trackPage: eucex(getCurrentPath()) });
        } else {
          ninjaConfig.dataLayer.push({ trackPage: 'home' });
        }
      }
    } else {
      checkParam();
    }

    // Init laquesis

    if (inArray(getPluginList(), 'LQ')) {
      setTimeout(initLaquesis, 0);
    }
  }
} catch (error) {
  if (typeof trackError === 'function') {
    trackError('JAVASCRIPT_ERROR', currentTracker, '', error);
  }
}

// exports.getIdentifiers = function () {
//   return getIdentifiers();
// };

/**
 * Track ninja event
 * @param {String | String[]} eventName Event to track
 * @param {Record<string, any>} params
 */
function trackEvent(eventName, params) {
  var trackParams;
  if (eventName && ninjaConfig.dataLayer) {
    trackParams = extend(params || {}, {
      trackEvent: isArray(eventName) ? eventName : [eventName],
    });
    ninjaConfig.dataLayer.push(trackParams);
  }
}

/**
 * Track page
 * @param {String} name page name
 * @param {Record<string, any>} params
 */
function trackPage(name, params) {
  var trackParams = extend(params || {}, { trackPage: name });

  ninjaConfig.dataLayer.push(trackParams);
}

export default {
  currentSession: currentSession,
  trackEvent: trackEvent,
  trackPage: trackPage,

  trackEventDelayed: trackEventDelayed,
  trackPageDelayed: trackPageDelayed,
  flushDelayed: flushDelayed,
};
